import { PAYOUT_ACCOUNT } from '../models/payout-account';
import { PAYOUT_METHOD } from '../models/payout-method';
import { INLINE_SVG_NAMES } from './inline-svgs';

export const getAccountMethodIcon = (type, method) => {
  switch (type) {
    case PAYOUT_ACCOUNT.ACCOUNT_TYPES.BANK:
      return INLINE_SVG_NAMES.PAYOUT_METHOD_BANK;
    case PAYOUT_ACCOUNT.ACCOUNT_TYPES.CUSTOM:
      return INLINE_SVG_NAMES.PAYOUT_METHOD_CUSTOM;
    case PAYOUT_ACCOUNT.ACCOUNT_TYPES.HYPERWALLET:
      switch (method) {
        case PAYOUT_METHOD.HYPERWALLET_ACCOUNT_METHODS.BANK:
          return INLINE_SVG_NAMES.PAYOUT_METHOD_BANK;
        case PAYOUT_METHOD.HYPERWALLET_ACCOUNT_METHODS.PAYPAL:
          return INLINE_SVG_NAMES.PAYOUT_METHOD_PAYPAL;
        case PAYOUT_METHOD.HYPERWALLET_ACCOUNT_METHODS.VENMO:
          return INLINE_SVG_NAMES.PAYOUT_METHOD_VENMO;
        case PAYOUT_METHOD.HYPERWALLET_ACCOUNT_METHODS.WIRE:
          return INLINE_SVG_NAMES.PAYOUT_METHOD_WIRE;
        default:
          return '';
      }
    case PAYOUT_ACCOUNT.ACCOUNT_TYPES.PAYONEER:
      return INLINE_SVG_NAMES.PAYOUT_METHOD_PAYONEER;
    case PAYOUT_ACCOUNT.ACCOUNT_TYPES.PAYPAL:
      return INLINE_SVG_NAMES.PAYOUT_METHOD_PAYPAL;
    default:
      return '';
  }
};
